// SimpleBanner.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export const SimpleBanner = () => {
  const bannerStyles = {
    banner: {
      background: 'linear-gradient(135deg, var(--saffron-deep) 0%, var(--saffron-dark) 100%)',
      padding: '80px 0',
      marginTop: '75px',
      color: 'var(--white-pure)',
      position: 'relative',
      overflow: 'hidden'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: 'url("https://via.placeholder.com/1920x600/E57B1C/FFFFFF?text=भारत+माता+की+जय")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: 0.2,
      mixBlendMode: 'overlay'
    },
    content: {
      position: 'relative',
      zIndex: 2
    },
    title: {
      fontSize: '3rem',
      fontWeight: 700,
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: '1.8rem',
      marginBottom: '1rem',
      color: 'var(--saffron-light)'
    },
    legacyBox: {
      backgroundColor: 'rgba(255,255,255,0.1)',
      border: '2px solid var(--white-pure)',
      borderRadius: '50px',
      padding: '0.5rem 1.5rem',
      display: 'inline-block',
      marginBottom: '1.5rem'
    }
  };

  return (
    <section style={bannerStyles.banner} id="home">
      <div style={bannerStyles.overlay}></div>
      <Container style={bannerStyles.content}>
        <Row>
          <Col lg={8}>
            <div style={bannerStyles.legacyBox}>
              🪷 पौत्र: अमर स्वतंत्रता सेनानी पंडित भगवान दीन शर्मा जी
            </div>
            
            <h1 style={bannerStyles.title}>पंडित धीरेंद्र कुमार शर्मा</h1>
            <h2 style={bannerStyles.subtitle}>सनातनी योद्धा एवं जनसेवक</h2>
            
            <p style={{fontSize: '1.2rem', marginBottom: '2rem'}}>
              144 विधानसभा, मोहम्मदी (खीरी)
            </p>
            
            <div style={{
              borderLeft: '5px solid var(--white-pure)',
              padding: '1rem 2rem',
              backgroundColor: 'rgba(255,255,255,0.1)',
              borderRadius: '0 30px 30px 0',
              fontSize: '1.2rem',
              fontStyle: 'italic',
              maxWidth: '600px'
            }}>
              "विरासत राष्ट्रभक्ति की, संकल्प जन-सेवा का — पंडित धीरेंद्र कुमार शर्मा, मोहम्मदी का अटूट विश्वास।"
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};